import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-cookie-consent', 'mainTitle', 'Our cookies, your choices');
Labels.set('ui-cookie-consent', 'settingsTitle', 'Cookie settings');
Labels.set(
    'ui-cookie-consent',
    'mainInfo',
    'Swedbank Group {entitiesLink} registered in {country} use {cookiesLink} or similar technologies that are necessary for this website to function. There are also cookies you can choose to improve and personalize your experience:'
);
Labels.set(
    'ui-cookie-consent',
    'secondaryInfo',
    'You can manage your choice of optional cookies by pressing “Manage cookies”. You may withdraw your consent at any time on our {usageLink}. For more information on how we use cookies, please see our {policyLink}.'
);
Labels.set(
    'ui-cookie-consent',
    'settingsInfo',
    'You may withdraw your consent at any time on our {usageLink}. For more information on how we use cookies, please see our {policyLink}.'
);
Labels.set(
    'ui-cookie-consent',
    'thirdPartyDisclaimer',
    'Third-party cookies are used on this website.'
);
Labels.set('ui-cookie-consent', 'accept', 'Accept all cookies');
Labels.set('ui-cookie-consent', 'decline', 'Accept only necessary cookies');
Labels.set('ui-cookie-consent', 'myCookies', 'Manage cookies');
Labels.set('ui-cookie-consent', 'saveChoice', 'Save cookie settings');
Labels.set('ui-cookie-consent', {
    HELP_NECESSARY:
        'Necessary for the website to work smoothly and securely and cannot be deselected. Enable important functions such as login and language settings.',
    HELP_ANALYTICAL:
        'Help us understand how users use our site, which functions are popular, which features might be complicated. We use this data to improve our site. If decline, no statistics will be collected.',
    HELP_TARGETING:
        'Help to provide you with personalized information about our products and services. If declined personalized content will not be presented to you. ',
    HELP_FUNCTIONAL:
        'Make your browsing experience smoother. Without them, you might have to re-enter, filter content repeatedly, scroll more and miss out on other useful features. ',
});
Labels.set('ui-cookie-consent', {
    CATEGORY_NECESSARY: 'Necessary',
    CATEGORY_ANALYTICAL: 'Analytical',
    CATEGORY_TARGETING: 'Targeting',
    CATEGORY_FUNCTIONAL: 'Functional',
});
Labels.set('ui-cookie-consent', {
    COOKIE_ANALYTICAL: 'Analytical',
    COOKIE_TARGETING: 'Targeting',
    COOKIE_FUNCTIONAL: 'Functional',
});
Labels.set('ui-cookie-consent', 'EE', 'Estonia');
Labels.set('ui-cookie-consent', 'LV', 'Latvia');
Labels.set('ui-cookie-consent', 'LT', 'Lithuania');
Labels.set('ui-cookie-consent', 'entities', 'entities');
Labels.set('ui-cookie-consent', 'cookies', 'cookies');
Labels.set('ui-cookie-consent', 'language', 'Language');
Labels.set('ui-cookie-consent', 'usage', 'Cookies usage page');
Labels.set('ui-cookie-consent', 'policyLinkLabel', 'Cookie Policy');
